import { EmailFormSection } from "@/modules/email-templates-sidebar/content/v2/sections/email-form-section";
import { FollowupPreviewSection } from "@/modules/email-templates-sidebar/content/v2/sections/followup-preview-section";
import { PreviewSettingsSection } from "@/modules/email-templates-sidebar/content/v2/sections/preview-settings-section";
import { Divider } from "@/modules/email-templates-sidebar/shared/divider";

import { PromptSection } from "@/modules/email-templates-sidebar/content/v2/sections/prompt-section";

export const EmailTemplateRegularMode = () => {
  return (
    <div className="grid grid-cols-[60%_40%] p-5 pb-24">
      <div className="flex w-full flex-col gap-4">
        <PromptSection />

        <Divider />

        <EmailFormSection />

        <PreviewSettingsSection />
      </div>

      <FollowupPreviewSection className="w-full" />
    </div>
  );
};
